import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  effect,
  inject,
  OnInit,
  PLATFORM_ID,
  signal,
  Signal,
} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { RouteSlug } from '@www/_models';
import { AppState } from '@www/app.state';
import { select, Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { FormErrorHandlerService } from '@www/_services';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActionEndedComponent } from '@www/_components/modals/action-ended/action-ended.component';
import { DataLayerService } from '@www/_helpers';

export const SPINNER_NAME = 'CORE_SPINNER_NAME';

@Directive()
export abstract class BasicPage implements OnInit {
  protected readonly RouteSlug = RouteSlug;
  protected readonly _isBrowser: boolean;
  protected readonly _isServer: boolean;
  protected readonly _ngxSpinnerService: NgxSpinnerService = inject(NgxSpinnerService);
  protected readonly _toastrService: ToastrService = inject(ToastrService);
  protected readonly _platformId: Object = inject(PLATFORM_ID);
  protected readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  protected readonly _destroyRef: DestroyRef = inject(DestroyRef);
  protected readonly _store: Store = inject(Store);
  protected readonly _formErrorHandlerService: FormErrorHandlerService = inject(FormErrorHandlerService);
  protected readonly _ngbModal: NgbModal = inject(NgbModal);
  protected readonly _dataLayerService: DataLayerService = inject(DataLayerService);

  public readonly appStateLoading = select(AppState.loading);
  public abstract readonly loading: Signal<boolean>;

  protected constructor() {
    this._isBrowser = isPlatformBrowser(this._platformId);
    this._isServer = isPlatformServer(this._platformId);
    this._setLoadingEffect();
  }

  public ngOnInit(): void {
    if (this._isServer) {
      return;
    }
  }

  protected _openEndActionModal(modalCommunicate?: string | null): Promise<unknown> {
    if (this._isServer) {
      return Promise.resolve();
    }
    const ngbModalRef = this.openComponentInModalAndGetRef(ActionEndedComponent);
    ngbModalRef.componentInstance.modalCommunicate = modalCommunicate
      ? signal(modalCommunicate)
      : signal(`
        <h1 class="mb-lg-4 mb-3">Dziękujemy za wszystkie nadesłane zgłoszenia!</h1>
        <p>Informujemy, że konkurs dobiegł końca, a zapisy zostały wstrzymane.</p>
      `);
    return ngbModalRef.result;
  }

  private _setLoadingEffect(): void {
    effect(() => {
      if (this.appStateLoading() || this.loading()) {
        this._ngxSpinnerService.show(SPINNER_NAME).then();
      } else {
        this._ngxSpinnerService.hide(SPINNER_NAME).then();
      }
      setTimeout(() => {
        this._ngxSpinnerService.hide(SPINNER_NAME).then();
      }, 12000);
    });
  }

  private openComponentInModalAndGetRef(component: typeof ActionEndedComponent): NgbModalRef {
    return this._ngbModal.open(component, {
      centered: true,
      backdrop: 'static',
      keyboard: true,
      size: 'lg',
    });
  }
}
